module.exports = __webpack_public_path__ + "img/logo_row_white_zh.a5b58ad4.svg";